import React, { Component } from 'react';
class Banner extends Component {
    state = {  }
    render() { 
        return (
            <React.Fragment>
            <header className="header">
                <div className="fashion-banner">
                    <div className="header-green-container"></div>
                    <div className="banner-text">
                        <div className="banner-title">
                            <h1 className="fuente-monserrat"> Diseño de Moda</h1>
                        </div>
                        {/* <div className="banner-descrip">
                            <p align="justify" className="fuente-monserrat parrafo-grande">
                                La carrera de Diseño de Moda forma profesionales capacitados para impulsar el desarrollo de proyectos competitivos, creativos e innovadores, apegados a los valores formales y funcionales del mercado de la moda, con la finalidad de satisfacer las demandas y requerimientos del mercado, dentro de los ámbitos locales, nacionales, regionales e internacionales.
                            </p>
                        </div>
                        <div>
                            <a className="btn btn-danger fuente-monserrat" href="docs/PlanDModa.pdf" target="_blank" style={{borderWidth: 1, borderColor:"#a80012", backgroundColor:"#a80012", color:"#FFF"}} title="Descargar el Plan de Estudios">Plan de Estudio <i className="fa fa-download"></i></a>
                        </div> */}
                    </div>
                </div>
            </header>
            </React.Fragment>
        );
    }
}
 
export default Banner;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoModa/Banner.jsx